export const toHuman =(amount: number)=>{
    return parseFloat((amount / 100000000).toFixed(1));
}

export const formatAddress = (address: string)=>{
    return address.substr(0, 10) + "....." + address.substr(address.length - 5);
}